export enum FacetSortTypeEnum {
  CUSTOM = 'CUSTOM',
  ALPHABETICALLY = 'ALPHABETICALLY',
  RESULTS_NUMBER = 'RESULTS_NUMBER',
}
